/*
 * @Date: 2018-12-27 15:58:57
 * @LastEditors: zwj
 * @LastEditTime: 2023-10-30 12:12:08
 */
import axios from 'axios'
import router from '../router/index'
import { getUserBizInfo, removeUserInfo } from '@/utils/storage'
import CryptoJs from 'crypto-js'
import Vue from 'vue'
import {MessageBox} from 'element-ui'

// Vue.use(MessageBox)

// 创建axios实例
const service = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_URL, // api的base_url
  timeout: 300000, // 请求超时时间
  headers: {'Content-Type': 'application/json;charset=UTF-8'}
})

// request拦截器
service.interceptors.request.use(
  config => {
    let conData = config.data
    // console.log(config.url,conData)
    let userInfo = getUserBizInfo()
    if (userInfo) {
      config.headers.AdminAuthorization = userInfo.token
	  config.headers.account = userInfo.admin_info.account
	  config.headers.userId = userInfo.admin_info.id
      config.headers.XApplicationType = 'bms'
    }
    let key = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_ENTRYKEY)
    let iv = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_IV)
    let datas = CryptoJs.enc.Utf8.parse(JSON.stringify(config.data))
    let encrypted = CryptoJs.AES.encrypt(datas,key,{iv: iv})
    if(config.data) config.data = encrypted.toString()
    // console.log(config.data);

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    // console.log('响应', response)
    if (response.data.code == 10001) {
      return MessageBox.alert('登录超时，请重新登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          removeUserInfo()
          router.push({
            path: '/login'
          })
        }
      })
    }
    let key = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_ENTRYKEY)
    let iv = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_IV)
    if(response.data.data && typeof(response.data.data) == 'string') response.data.data = JSON.parse(CryptoJs.AES.decrypt(response.data.data, key, {iv: iv}).toString(CryptoJs.enc.Utf8))
    // console.log(response.config.method,response.config.url,response.data)
    return response.data
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service

// 参数里面有offset的 只要传page 和 size
